import cn from 'classnames';
import { forwardRef, HTMLProps } from 'react';
import { SizeType, VariantType } from '../../types/props';
import s from './message.module.css';

export interface MessageProps extends Omit<HTMLProps<HTMLDivElement>, 'size'> {
  size?: SizeType;
  variant?: VariantType;
  description: string;
}

export const Message = forwardRef<HTMLDivElement, MessageProps>((props, ref) => {
  const { size = 'sm', variant = 'primary', className, label, description, ...other } = props;

  const classNames = cn(s.component, className, s[size], s[variant]);

  return (
    <div {...other} ref={ref} className={classNames} data-testid="message">
      {label && <h4 className={s.label}>{label}</h4>}
      <p className={s.description}>{description}</p>
    </div>
  );
});
